import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { CloseButton } from '../CloseButton';
import type { RootReduxState } from 'app/shared/flux/reducers/index';
import * as styles from './detailPanel.styles';

type DetailPanelHeaderProps = {
  onClose: () => void;
  actions?: ReactNode;
};

export const DetailPanelHeader = ({ onClose, actions }: DetailPanelHeaderProps) => {
  const listing = useSelector((state: RootReduxState) => state.currentListingDetails.currentListing);
  const propertyName =
    (listing as unknown as { propertyName?: string })?.propertyName ||
    (listing as unknown as { displayName?: string })?.displayName ||
    listing?.address?.street ||
    '';

  return (
    <header className={styles.panelHeader}>
      <div className={styles.panelHeaderColumns}>
        <div className={styles.panelHeaderColumn1}>
          <CloseButton onClick={onClose} aria-label="Close panel" />
        </div>
        <div className={styles.panelHeaderColumn2}>
          <h2 className={styles.panelHeaderTitle}>{propertyName}</h2>
        </div>
        <div className={styles.panelHeaderColumn3}>{actions}</div>
      </div>
    </header>
  );
};
